// oh, RFC 6902 compliant types for operations. See http://jsonpatch.com/
export enum JSONPatchOperationType {
    Add = "add",
    Remove = "remove",
    Replace = "replace",
    Copy = "copy",
    Move = "move",
    Test = "test"
}